import { Box } from "@chakra-ui/react";

interface IBaseRadioProps {
  isActive: boolean;
  externalHover?: boolean;
}

const BaseRadio: React.FC<IBaseRadioProps> = ({ isActive, externalHover }) => (
  <Box
    position="relative"
    width="8px"
    height="8px"
    borderRadius="full"
    background={isActive ? "ud-primary" : "transparent"}
    transition="background 0.2s"
    cursor="pointer"
    padding={0}
    margin="6px"
  >
    <Box
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      width="16px"
      height="16px"
      borderWidth="2px"
      borderStyle="solid"
      borderColor={isActive || externalHover ? "ud-primary" : "ud-grey-200"}
      borderRadius="full"
      transition="border-color 0.2s"
    />
  </Box>
);

export default BaseRadio;
